import React from 'react';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MuiTooltip, {
  tooltipClasses,
  TooltipProps as MuiTooltipProps,
} from '@mui/material/Tooltip';

import { C_BLACK, C_WHITE } from '../../utils/colors';
import { pxToRem } from '../../utils/functions';
import { FONT_SIZES } from '../../utils/variables';

import { TooltipComponentProps, TooltipProps } from './tooltip-types';

const StyledTooltip = styled(({ className, ...props }: MuiTooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: C_BLACK,
    color: C_WHITE,
    maxWidth: pxToRem(255),
    padding: pxToRem([12, 14]),
    fontSize: FONT_SIZES.base(),
    lineHeight: '120%',
    borderRadius: pxToRem(2),
    '& *': {
      color: C_WHITE,
    },
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: C_BLACK,
  },
}));

const TooltipComponent = ({
  children,
  title,
  placement,
  style,
  interactive,
}: TooltipComponentProps) => {
  return (
    <StyledTooltip
      title={title}
      placement={placement ?? 'bottom'}
      style={style}
      disableInteractive={!interactive}
      arrow
    >
      {children}
    </StyledTooltip>
  );
};

const Tooltip = ({
  children,
  title,
  placement,
  style,
  interactive,
  icon,
}: TooltipProps) => {
  return children ? (
    <>
      {children?.props?.disabled ? (
        <div aria-label={`${title}`}>{children}</div>
      ) : (
        <TooltipComponent
          title={title}
          placement={placement}
          style={style}
          interactive={interactive}
        >
          <div>{children}</div>
        </TooltipComponent>
      )}
    </>
  ) : (
    <TooltipComponent
      title={title}
      placement={placement}
      interactive={interactive}
    >
      <IconButton className="tooltip__button" size="small">
        {icon ?? <QuestionMarkIcon />}
      </IconButton>
    </TooltipComponent>
  );
};

export default Tooltip;
